import React, { useEffect, useState } from 'react';
import { fetchBatons } from '../utils/api';
import './Personnel.css';

const statusColor = { 'On Duty': '#22c55e', 'On Break': '#f59e0b', 'Inactive': '#a855f7', 'Offline': '#64748b' };

const Personnel = () => {
  const [batons, setBatons] = useState([]);
  const [filter, setFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const params = { page, limit: 20 };
        if (statusFilter) params.status = statusFilter;
        const res = await fetchBatons(params);
        setBatons(res.data.batons);
        setTotal(res.data.total);
      } catch {
        setBatons([]);
      }
    };
    load();
  }, [page, statusFilter]);

  const filtered = batons.filter(b =>
    !filter || b.assignedTo?.toLowerCase().includes(filter.toLowerCase()) || b.batonId?.includes(filter)
  );

  return (
    <div className="personnel-page">
      <div className="page-header">
        <h2>Deployment Roaster</h2>
        <div className="page-controls">
          <input
            className="search-input"
            placeholder="Search by name or ID..."
            value={filter}
            onChange={e => setFilter(e.target.value)}
          />
          <select className="filter-select" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
            <option value="">All Status</option>
            <option value="On Duty">On Duty</option>
            <option value="On Break">On Break</option>
            <option value="Inactive">Inactive</option>
            <option value="Offline">Offline</option>
          </select>
        </div>
      </div>
      <div className="personnel-table-wrap">
        <table className="personnel-table">
          <thead>
            <tr>
              <th>Baton ID</th>
              <th>Officer</th>
              <th>Badge</th>
              <th>Unit</th>
              <th>Zone</th>
              <th>Status</th>
              <th>Battery</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length > 0 ? filtered.map(b => (
              <tr key={b.batonId || b._id}>
                <td><span className="mono">{b.batonId}</span></td>
                <td>{b.assignedTo}</td>
                <td><span className="mono">{b.badgeNumber}</span></td>
                <td>{b.unit}</td>
                <td>{b.zone}</td>
                <td>
                  <span className="status-badge" style={{ color: statusColor[b.status] || '#64748b', borderColor: statusColor[b.status] || '#64748b' }}>
                    {b.status}
                  </span>
                </td>
                <td>
                  <div className="battery-bar">
                    <div className="battery-fill" style={{ width: `${b.batteryLevel}%`, background: b.batteryLevel < 20 ? '#ef4444' : b.batteryLevel < 50 ? '#f59e0b' : '#22c55e' }}></div>
                  </div>
                  <span className="battery-pct">{b.batteryLevel}%</span>
                </td>
                <td>{b.location?.address || 'Vijayawada'}</td>
              </tr>
            )) : (
              <tr><td colSpan="8" className="empty-row">No data available. Start backend and seed the database.</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
        <span>Page {page} · Total {total} records</span>
        <button disabled={filtered.length < 20} onClick={() => setPage(p => p + 1)}>Next →</button>
      </div>
    </div>
  );
};

export default Personnel;
